// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import {Select} from '../../hola/pub/lib/select';

interface i_title_tag_input_props {
    value?: string;
    on_select:(v:string)=>void;
    label?:string;
}
interface i_dynamic_heading_props {
    tag?: string;
    children?: React.ReactNode;
    className?: string;
    dangerouslySetInnerHTML?: { __html: string | TrustedHTML };
}

const allowed_tags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p'] as const;
const items_headings = allowed_tags.map(tag=>({
    value: tag,
    title: tag,
    rendered_item: <div><strong>Tag {tag.toLocaleUpperCase()}</strong></div>,
}));

export const Title_header_select = ({value, on_select,
    label}: i_title_tag_input_props)=><Select items={items_headings}
      value={value} on_select={(n, v)=>on_select(v)} size={'sm'}
      label={label || 'Title tag (e.g. h1, h5)'} />;

type t_heading_tag = typeof allowed_tags[number];

export const Dynamic_heading = (props: i_dynamic_heading_props)=>{
    const {tag = 'h2', children, className, dangerouslySetInnerHTML} = props;
    const safe_tag = allowed_tags.includes(tag as t_heading_tag)
        ? (tag as t_heading_tag) : 'h1';
    const Tag = safe_tag as keyof JSX.IntrinsicElements;
    if (dangerouslySetInnerHTML)
    {
        return React.createElement(Tag, {
            className,
            dangerouslySetInnerHTML
        });
    }
    return <Tag className={className}>{children}</Tag>;
};
